module.exports = __webpack_public_path__ + "static/img/SIP-BDUvpnss.af8df45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/SIP-BDUvpnss.png
// module id = S5TQ
// module chunks = 16